import {
  Component,
  ComponentFactoryResolver,
  ElementRef,
  OnDestroy,
  OnInit,
  Renderer2,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';

import {
  FacebookLoginProvider,
  GoogleLoginProvider,
  SocialAuthService,
} from '@abacritt/angularx-social-login';
import { NgxSpinnerService } from 'ngx-spinner';
import { share } from 'rxjs/operators';

import {
  UntilDestroy,
  untilDestroyed,
} from '@ngneat/until-destroy';
import { LoginService } from '@services/auth.service';
import { CommonService } from '@services/common.service';
import { SharedService } from '@services/shared.service';
import { YTBSEOService } from '@services/ytb-seo.service';

import {
  ForgotpasswordComponent,
} from '../forgotpassword/forgotpassword.component';

// declare var JSEncrypt: any;
  
  @UntilDestroy()
  @Component({
    selector: 'external-login',
    templateUrl: './external-login.component.html',
    styleUrls: ['./external-login.component.scss'],
  })
  export class ExternalLoginComponent implements OnInit, OnDestroy {
    loginForm: UntypedFormGroup;
    resetForm: UntypedFormGroup;
    showSuccess: boolean = false;
    showFail: boolean = false;
    submitted: boolean = false;
    showreset: boolean = false;
    showlogin: boolean = true;
    password: boolean = false;
    invaliduser: boolean = false;
    userid: any;
    @ViewChild('closebtn') closebtn;
    @ViewChild('loginbtn') loginbtn;
    @ViewChild('load', { read: ViewContainerRef })
    private load: ViewContainerRef;
    @ViewChild('forgot') private forgotel: ElementRef;
    isNavigate: boolean = false;
  
    rememeberMe: boolean;
  
    showErrorMessage: boolean = false;
    showSuccessMessage: boolean = false;
    errorMessageInfo: Array<string> = [];
    isCoupon: boolean = false;
    key: string;
    isConfirmationEmail: boolean = false;
    forgotPassword: boolean = true;
  
    constructor(
      private fb: UntypedFormBuilder,
      private loginservice: LoginService,
      private elem: ElementRef,
      private renderer: Renderer2,
      private spinner: NgxSpinnerService,
      private shared: SharedService,
      private resolver: ComponentFactoryResolver,
      private router: Router,
      private authService: SocialAuthService,
      private ytbseo: YTBSEOService,
      private title: Title,
      private commonService: CommonService
    ) { }
  
    ngOnInit() {
      this.spinner.hide();
      /* Create login form */
      this.loginForm = this.fb.group({
        userId: ['', Validators.required],
        password: ['', Validators.required],
        actionType: [0],
        isRememberMe: [],
      });
  
      this.resetForm = this.fb.group({
        userId: ['', Validators.required],
        password: ['', Validators.required],
        confirmpassowrd: ['', Validators.required],
        actionType: [1],
      });
  
      this.loginservice.LoginSuccess.pipe(
        untilDestroyed(this),
        share()
      ).subscribe((payload) => {
        if (payload) {
          this.spinner.hide();
          this.isConfirmationEmail = false;
          if (payload?.successCode) {
            this.shared.setUserIdAfterLogin(payload.result.userName);
            this.shared.setLoginUserDetails((payload.result));
            this.errorMessageInfo = payload.messageInfo.uiSuccessMessge;
            this.showSuccessMessage = true;
            this.showErrorMessage = false;
  
            setTimeout(() => {
              this.showErrorMessage = false;
              this.showSuccessMessage = false;
              this.errorMessageInfo = [];
              this.hideLogin();
              this.enableMyAccount();
              this.loginForm.controls["userId"].reset();
              this.loginForm.controls["password"].reset();
            }, 3000);
          } else if (!payload.successCode) {
            this.errorMessageInfo = payload.messageInfo.uiErrorMessage;
            if (payload.messageInfo.errorCode === 'CMER012')
              this.isConfirmationEmail = true;
            this.showSuccessMessage = false;
            this.showErrorMessage = true;
          } else {
            this.errorMessageInfo.push(
              'Unable to perform this operation at this time'
            );
            this.showSuccessMessage = false;
            this.showErrorMessage = true;
          }
        } else {
          this.spinner.hide();
  
          this.errorMessageInfo.push(
            'Unable to perform this operation at this time'
          );
  
          this.showSuccessMessage = false;
          this.showErrorMessage = true;
        }
      });
  
      this.loginservice.onFailure
        .pipe(untilDestroyed(this), share())
        .subscribe((response) => {
          if (response) {
            this.spinner.hide();
  
            if (response.exceptionSource == 'Login_Issue') {
               this.commonService.logError({
                logLevel: "Login_Issue",
                message:
                  "Navigating to Error page from External Login Component from Login_Issue", 
              });
              this.router.navigate(['error']);
            }
          }
        });
  
      this.shared.forgotchangedtls$.subscribe((params) => {
        if (params == 'login') {
          this.renderer.removeClass(this.forgotel.nativeElement, 'is-flipped');
          this.forgotPassword = true;
        }
      });
  
  
      this.shared.logOutUserId
        .pipe(untilDestroyed(this), share())
        .subscribe((status) => {
          if (status != undefined && status != null) {
            if (status) {
              this.loginForm.controls["userId"].reset();
              this.loginForm.controls["password"].reset();
  
            }
          }
        });
  
      this.authService.authState.subscribe(user => {
        console.log("== user == Auth State    ", user);
        console.log(JSON.stringify(user));
        setTimeout(() => {
          this.closePopUp();
          if (user != null) {
            this.saveResponse(user);
          }
        }, 3000);
      })
  
      this.loginservice.SocialLoginSuccess.pipe(
        untilDestroyed(this),
        share()
      ).subscribe((response) => {
        if (response != null && response != undefined) {
        }
      });
  
      this.authService.initState.subscribe(user => {
      });
  
  
      this.commonService.RESENDEMAILCONFIRMATIONSSUCCESS.pipe(
        untilDestroyed(this),
        share()
      ).subscribe((res) => {
        if (res) {
          this.spinner.hide();
          this.isConfirmationEmail = false;
  
          if (res.successCode) {
            this.showSuccessMessage = true;
            this.showErrorMessage = false;
            this.errorMessageInfo = res.messageInfo.uiSuccessMessge;
          } else {
            this.showErrorMessage = true;
            this.showSuccessMessage = false;
            this.errorMessageInfo = res.messageInfo.uiErrorMessage;
          }
        }
      });
  
      this.loginForm.controls["userId"].reset();
      this.loginForm.controls["password"].reset();
  
  
  
      this.commonService.keySuccess$
        .pipe(untilDestroyed(this), share())
        .subscribe((key) => {
          if (key != null && key != undefined) {
            this.key = key.data;
          }
        });
  
    }
  
    ngAfterViewInit() {
      this.loginForm.controls["userId"].reset();
      this.loginForm.controls["password"].reset();
    }
  
    resendEmailConfirmation() {
      this.invaliduser = false;
      this.errorMessageInfo = [];
      this.isConfirmationEmail = false;
  
      this.submitted = true;
  
      if (this.loginForm.valid) {
        this.spinner.show();
        this.commonService.resendEmailConfirmation(this.loginForm.value);
      } else {
        this.commonService.validateAllFormFields(this.loginForm);
      }
    }
  
    navigateToSignup() {
      this.closePopUp();
    }
  
    closePopUp() {
      this.isConfirmationEmail = false;
      this.errorMessageInfo = [];
      this.showErrorMessage = false;
  
      if (this.closebtn) {
        this.closebtn.nativeElement.click();
      }
    }
  
    // convenience getter for easy access to form controls
    get f() {
      return this.loginForm.controls;
    }
  
    /**
     * @author : Ryan Marshal
     * @description : This method is used to submit login details
     */
    submitLogin() {
      this.errorMessageInfo = [];
      this.showErrorMessage = false;
      this.isConfirmationEmail = false;
  
      this.submitted = true;
      if (this.loginForm.valid) {
        this.submitted = false;
        this.rememeberMe = this.loginForm.controls['isRememberMe'].value;
        this.spinner.show();
        // var jsencrypt = new JSEncrypt();
  
  
        if (!this.showreset) {
          console.log(this.key)
          // jsencrypt.setPublicKey(this.key);
          console.log(this.loginForm.value);
  
  
          this.loginForm.value['password'] = this.commonService.encryptData(
            JSON.stringify(this.loginForm.value['password']),this.key
          );
          // jsencrypt = null;
  
          console.log(this.loginForm.value);
          this.loginservice.newLogin(this.loginForm.value);
        } else {
  
  
          console.log(this.key)
          // jsencrypt.setPublicKey(this.key);
          console.log(this.loginForm.value);
  
          this.resetForm.value['password'] = this.commonService.encryptData(
            JSON.stringify(this.resetForm.value['password']),this.key
          );
          this.resetForm.value['confirmpassowrd'] = this.commonService.encryptData(
            JSON.stringify(this.resetForm.value['confirmpassowrd']),this.key
          );
  
          // jsencrypt = null;
  
          this.loginservice.newLogin(this.resetForm.value);
        }
      }
    }
  
    /**
     * @author : Ryan Marshal
     * @description : This method is used to validate token
     */
    validateToken() {
      this.errorMessageInfo = [];
      this.showErrorMessage = false;
  
      this.loginservice.validateToken();
    }
  
    hideLogin() {
      this.errorMessageInfo = [];
      this.showErrorMessage = false;
  
      this.showSuccess = false;
      this.closebtn.nativeElement.click();
    }
  
    enableMyAccount() {
      this.errorMessageInfo = [];
      this.showErrorMessage = false;
  
      this.shared.loginSuccess.next(false);
    }
  
    ngOnDestroy() {
      this.spinner.hide();
      this.loginservice.dispose();
      this.loginservice.TokenValid.next(undefined);
    }
  
    cancel() {
      this.errorMessageInfo = [];
      this.showErrorMessage = false;
  
      this.renderer.removeClass(this.forgotel.nativeElement, 'is-flipped');
      this.forgotPassword = true;
    }
  
    loadComponent(typeofhelp: string) {
      this.errorMessageInfo = [];
      this.showErrorMessage = false;
  
      let component: any = this.getComponent(typeofhelp);
      this.load.clear();
      let Component = this.resolver.resolveComponentFactory(component);
      this.load.createComponent(Component);
      this.renderer.addClass(this.forgotel.nativeElement, 'is-flipped');
    }
  
    getComponent(component: string) {
      this.errorMessageInfo = [];
      this.showErrorMessage = false;
  
      if (component === 'forgotpassword') {
        this.forgotPassword = false;
        return ForgotpasswordComponent;
      }
    }
  
    resetlogin() {
      this.errorMessageInfo = [];
      this.showErrorMessage = false;
      this.isConfirmationEmail = false;
  
      this.submitted = true;
      if (this.resetForm.valid) {
        this.submitted = false;
        this.spinner.show();
        this.commonService.getKey();
        //this.loginservice.newLogin(this.resetForm.value);
      }
    }
  
    loginwithGoogle(socialProvider: string) {
      this.isConfirmationEmail = false;
      this.errorMessageInfo = [];
      this.showErrorMessage = false;
      let socialPlatformProvider;
      if (socialProvider === 'facebook') {
        socialPlatformProvider = FacebookLoginProvider.PROVIDER_ID;
      } else if (socialProvider === 'google') {
        socialPlatformProvider = GoogleLoginProvider.PROVIDER_ID;
      }
      console.log(socialPlatformProvider);
      this.authService.signIn(socialPlatformProvider);
    }
  
    saveResponse(socialUsers) {
      this.isConfirmationEmail = false;
  
      this.errorMessageInfo = [];
      this.showErrorMessage = false;
  
      console.log(JSON.stringify(socialUsers));
      // localStorage.setItem('UserID', socialUsers.email);
      this.shared.setUserIdAfterLogin(socialUsers.email);
      this.shared.setUserIdAfterLogin(socialUsers.email);
  
      let userObj = {
        ProviderName: socialUsers.provider,
        ProviderId: socialUsers.id,
        FirstName: socialUsers.firstName,
        LastName: socialUsers.lastName,
        MiddleName: '',
        Email: socialUsers.email,
        Image: socialUsers.photoUrl,
        Status_Code: 1,
        Device_Type: 1,
        userName: socialUsers.email,
        UserId: socialUsers.email
      };
      this.hideLogin();
      this.enableMyAccount();
      this.shared.setLoginUserDetails(userObj);
  
      setTimeout(() => {
        this.loginservice.socialLogin(userObj);
  
      }, 5000);
  
    }
  }
  